export default [
  {
    path: '/polls',
    name: 'polls',
    component: () => import('@/views/pages/poll/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.polls',
      resource: 'poll',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/polls/add',
    name: 'add-poll',
    component: () => import('@/views/pages/poll/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.polls',
      resource: 'poll',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/polls/modify/:id',
    name: 'modify-poll',
    component: () => import('@/views/pages/poll/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.polls',
      resource: 'poll',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
